import React from "react";

import Routes from "./routes";

export default function App() {
  const handelRightClick = (event) => {
    event.preventDefault();
  }

  React.useEffect(() => {
    document.addEventListener('contextmenu', handelRightClick);
  }, [])
  return (
      <Routes />
  );
}
